import styled from "styled-components";
import { Nav } from "react-bootstrap";
import { } from "../../../constants";

export const TabHeader = styled(Nav)`
  text-align: center;
  justify-content: center;
`;
